import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import TextField from '../components/TextField';
import PriceField from '../components/PriceField';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {Separator} from '../components/common/CustomBootstrap';
import {application, baseTokenSymbol} from '../constants/configs';
import {trim, sortBy} from 'lodash';

class TradeFeeLevelForm extends React.Component {
  createLevel = async info => {
    this.props.addLevel(info);
    ModalManager.close({
      isOpen: false
    });
  };

  updateLevel = async info => {
    this.props.editLevel(info);
    ModalManager.close({
      isOpen: false
    });
  }

  getDefaultFiatFees = () => {
    const {policy} = this.props;
    if (policy.levels.fiat[0].fees.length) {
      return policy.levels.fiat[0].fees.map(obj => ({maker: '0', taker: '0', user: obj.user}));
    }
    return [{maker: '0', taker: '0', user: `__${application.platformName}__`}];
  };

  getDefaultCryptoFees = () => {
    const {policy} = this.props;
    if (policy.levels.crypto[0].fees.length) {
      return policy.levels.crypto[0].fees.map(obj => ({maker: '0', taker: '0', user: obj.user}));
    }
    return [{maker: '0', taker: '0', user: `__${application.platformName}__`}];
  };

  getInitialValues = () => {
    const {level, policy} = this.props;
    return {
      level: level && level.length ? level[0].level : policy.levels.fiat.length + 1,
      max: level && level.length ? level[0].max : undefined,
      fiatFees: level && level.length ? level[0].fees.length ? level[0].fees : this.getDefaultFiatFees() : this.getDefaultFiatFees(),
      cryptoFees: level && level.length ? level[1].fees.length ? level[1].fees : this.getDefaultCryptoFees() : this.getDefaultCryptoFees(),
    };
  }

  render() {
    const {t, level} = this.props;
    return(
      <FinalForm
        initialValues={this.getInitialValues()}
        onSubmit={level ? this.updateLevel : this.createLevel}
        render={({handleSubmit, submitting, hasValidationErrors, values}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <PriceField item={{
                    name: 'max',
                    i18n: t('30d trade volume'),
                    unit: t(baseTokenSymbol),
                  }}/>
                </Col>
              </Row>
              {sortBy(values.fiatFees, [obj => obj.user !== `__${application.platformName}__`]).map((obj, index) => (
                <div key={index}>
                  <Separator className='my-3'/>
                  <div className='text-info text-one font-weight-semibold mb-4'>
                    {t(`${trim(obj.user , '_')} user fee`)}
                  </div>
                  <Row>
                    <Col>
                      <TextField item={{
                        name: `fiatFees[${index}].maker`,
                        i18n: t('Fiat Maker'),
                        type: 'text',
                      }}/>
                    </Col>
                    <Col>
                      <TextField item={{
                        name: `fiatFees[${index}].taker`,
                        i18n: t('Fiat Taker'),
                        type: 'text',
                      }}/>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <TextField item={{
                        name: `cryptoFees[${index}].maker`,
                        i18n: t('Crypto Maker'),
                        type: 'text',
                      }}/>
                    </Col>
                    <Col>
                      <TextField item={{
                        name: `cryptoFees[${index}].taker`,
                        i18n: t('Crypto Taker'),
                        type: 'text',
                      }}/>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row className='mt-2'>
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {level ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(TradeFeeLevelForm);
